import PropTypes from 'prop-types';
import numeral from 'numeral';
import classNames from 'classnames';
import _ from 'underscore';
import { Checkbox } from '@evertrue/et-components';
import { FlexTable } from '@evertrue/sdk';
import StageResolver from 'apps/assignments/components/stage-resolver';
import { SELF_SELECTION_STRING, DEFAULT_GIVING_DATA_STRING } from 'apps/volunteers/constants';
import { Link } from '@evertrue/et-components';

const propTypes = {
  pools: PropTypes.array,
  loading: PropTypes.bool,
  total: PropTypes.number,
  paginationModel: PropTypes.object,
  handlePageChange: PropTypes.func,
  handleSelectPool: PropTypes.func,
  selectedPools: PropTypes.array,
  emptyStateMessage: PropTypes.node,
};

const defaultProps = {
  selectedPools: [],
  pools: [],
};

const VolunteerPoolsTableController = (props) => {
  return (
    <div style={{ height: 'calc(100vh - 240px)', overflowY: 'auto', width: '100%' }}>
      <FlexTable
        tableKey="volunteer-pools-table"
        loading={props.loading}
        getRowHeight={() => 'auto'}
        pageSizeOptions={[50]}
        paginationModel={props.paginationModel}
        onPaginationModelChange={props.handlePageChange}
        rowCount={props.total}
        emptyStateMessage={props.emptyStateMessage}
        emptyStateIcon={<></>}
        rows={props.pools}
        autosizeOptions={{
          columns: [
            'pools',
            'assigned_prospect_rate',
            'total_prospect_count',
            'giving_category',
            'self_selection',
            'stage_group',
          ],
          includeOutliers: true,
          includeHeaders: true,
          expand: true,
        }}
        columns={[
          {
            field: 'pools',
            headerName: 'Pool Name',
            flex: 1,
            minWidth: 200,
            sortable: false,
            hideable: false,
            renderCell: ({ row: pool }) => (
              <div className="volunteer-pools-table-controller--checkbox-cell">
                <Checkbox
                  label={`Select ${pool.name}`}
                  checked={Boolean(_.findWhere(props.selectedPools, { id: pool.id }))}
                  onChange={(bool) => {
                    props.handleSelectPool(pool, bool);
                  }}
                />
                <Link
                  className="ellipsis-overflow"
                  title={`Link to pool ${pool.name}`}
                  href={`volunteers/pool/${pool.id}`}
                >
                  {pool.name}
                </Link>
              </div>
            ),
          },
          {
            field: 'assigned_prospect_rate',
            headerName: '% Assigned',
            flex: 1,
            sortable: false,
            renderCell: ({ row: pool }) => (
              <div className="volunteer-pools-table-controller--assigned-rate">
                {numeral(pool.assigned_prospect_rate).format('0.0%')}
              </div>
            ),
          },
          {
            field: 'total_prospect_count',
            headerName: 'Volunteers & Prospects',
            flex: 1,
            sortable: false,
            renderCell: ({ row: pool }) => (
              <div>
                <div>{pool.total_solicitor_count} Volunteers</div>
                <div>{pool.total_prospect_count} Prospects</div>
              </div>
            ),
          },
          {
            field: 'giving_category',
            headerName: 'Giving Category',
            flex: 1,
            sortable: false,
            renderCell: ({ row: pool }) => (
              <div>
                {_.isNull(pool.giving_category_label) ? DEFAULT_GIVING_DATA_STRING : pool.giving_category_label}
              </div>
            ),
          },
          {
            field: 'self_selection',
            headerName: 'Self Selection',
            flex: 1,
            sortable: false,
            renderCell: ({ row: pool }) => {
              const is_enabled = pool.selection_mode === SELF_SELECTION_STRING;
              return (
                <div
                  className={classNames('volunteer-pools-table-controller--selection-mode-label', {
                    disabled: !is_enabled,
                  })}
                >
                  {is_enabled ? 'Enabled' : 'Disabled'}
                </div>
              );
            },
          },
          {
            field: 'stage_group',
            headerName: 'Stage Group',
            flex: 1,
            sortable: false,
            renderCell: ({ row: pool }) => (
              <StageResolver>
                {({ stageGroups, hasStagesFeature }) => {
                  if (!hasStagesFeature) return null;
                  const group = stageGroups[pool.stage_group_id] || {};
                  return <div>{group.name}</div>;
                }}
              </StageResolver>
            ),
          },
        ]}
      />
    </div>
  );
};

VolunteerPoolsTableController.propTypes = propTypes;

VolunteerPoolsTableController.defaultProps = defaultProps;

export default VolunteerPoolsTableController;
